import { MeetingResponse, getTaskMeeting } from '@reception-web/common/api/www'
import { AxiosError } from 'axios'
import useSWR from 'swr'

export const useTaskMeetingApi = (taskSid: string | undefined) => {
  const { data, error } = useSWR<MeetingResponse, AxiosError<Error>>(
    taskSid && `/aos/meeting/${taskSid}`,
    () => getTaskMeeting(taskSid ?? '').then((res) => res.data)
  )

  return {
    data,
    error,
  }
}
